function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _class2, _class3;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

import { Component, register, bind } from 'ovee.js';
import VanillaLazyLoad from 'vanilla-lazyload/dist/lazyload';
/*
 *   API:
 *   https://github.com/verlok/lazyload#-api
 *
 *   Avoid content reflow:
 *   https://github.com/verlok/lazyload#occupy-space-and-avoid-content-reflow
 */

var _class = (_dec = register('lazy-load'), _dec2 = bind('lazy-load'), _dec(_class2 = (_class3 = /*#__PURE__*/function (_Component) {
  _inherits(_class3, _Component);

  var _super = _createSuper(_class3);

  function _class3() {
    _classCallCheck(this, _class3);

    return _super.apply(this, arguments);
  }

  _createClass(_class3, [{
    key: "init",
    value: function init() {
      var _this = this;

      this.destroyInterval = null;
      this.mediaWrapper = this.$element.parentElement;
      this.lazyLoad = new VanillaLazyLoad({
        callback_loaded: function callback_loaded() {
          _this.updateParent();
        }
      }, [this.$element]);
      this.updateLazyLoad = this.updateLazyLoad.bind(this);
      this.bind();
    }
  }, {
    key: "updateLazyLoad",
    value: function updateLazyLoad() {
      this.lazyLoad.update();
    }
  }, {
    key: "updateParent",
    value: function updateParent() {
      if (this.mediaWrapper) {
        this.mediaWrapper.classList.add('media-loaded');
      }
    }
  }, {
    key: "loadTrigger",
    value: function loadTrigger() {
      VanillaLazyLoad.load(this.$element);
    }
  }, {
    key: "bind",
    value: function bind() {
      this.$on('lazy-update', window, this.updateLazyLoad);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this2 = this;

      this.$off('lazy-update', window, this.updateLazyLoad);
      this.destroyInterval = setInterval(function () {
        if (_this2.lazyLoad && _this2.lazyLoad.loadingCount && _this2.LazyLoad.loadingCount > 0) {
          return;
        }

        clearInterval(_this2.destroyInterval);
        if (_this2.lazyLoad.destroy) _this2.lazyLoad.destroy();
        _this2.lazyLoad = null;
      }, 250);
    }
  }]);

  return _class3;
}(Component), (_applyDecoratedDescriptor(_class3.prototype, "loadTrigger", [_dec2], Object.getOwnPropertyDescriptor(_class3.prototype, "loadTrigger"), _class3.prototype)), _class3)) || _class2);

export { _class as default };